/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import "../index.css";
import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  Suspense,
  lazy,
} from "react";
import WebSocket from "isomorphic-ws";
import moment from "moment";
import ThreeDotsLoader from "../components/ThreeDotsLoader";
import { useLocation, useNavigate } from "react-router-dom";
import { Remarkable } from "remarkable";
import { memo } from "react";
import axios from "axios";
import { Drawer, Button, Modal, Accordion } from "flowbite-react";
import { Table, DatePicker, Space, theme, Radio, Timeline } from "antd";
import dayjs from "dayjs";
import Loader from "../components/Loader";
import { v5 as uuidV5 } from "uuid";
import { clog } from "../lib/utils";
import DetailsDrawer from "../components/DetailsDrawer";
const Plot = lazy(() => import("react-plotly.js"));

const Chat = memo(function Chat({ wordPressDetails, reporting }) {
  const navigate = useNavigate();
  const NAMESPACE = "123e4567-e89b-12d3-a456-426614174000";
  const [fromDate, setFromDate] = useState(dayjs().add(-14, "d"));
  const [toDate, setToDate] = useState(dayjs());
  const [fromDateUserJ, setFromDateUserJ] = useState(dayjs().add(-14, "d"));
  const [toDateUserJ, setToDateUserJ] = useState(dayjs());
  const [fromDateUserK, setFromDateUserK] = useState(dayjs().add(-14, "d"));
  const [toDateUserK, setToDateUserK] = useState(dayjs());
  const [sessionType, setSessionType] = useState('1');
  const [isOpen, setIsOpen] = useState(false);
  const [rankingData, setrankingData] = useState({});
  const [userActivityData, setUserActivityData] = useState({
    userList: [],
    graphData: [],
  });
  const [userIdJourneyData, setUserIdJourneyData] = useState([]);
  const handleClose = () => setIsOpen(false);

  // DetailsDrawer state
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerData, setDrawerData] = useState(null);
  const textareaRef = useRef(null);
  const viewFilesRef = useRef(null);
  const fileInfoRef = useRef(null);
  const [videoUrl, setvideoUrl] = useState("");
  const [chatData, setChatData] = useState([]);
  const [fullscreenClicked, setfullscreenClicked] = useState(false);
  function getDate() {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();
    const date = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${date}`;
  }
  const location = useLocation();
  const [mounted, setmounted] = useState(false);
  const [showModal, setshowModal] = useState({
    first: false,
    second: false,
    third: false,
  });
  const [displayEditor, setdisplayEditor] = useState(false);
  const [popupMessage, setpopupMessage] = useState("");
  const [fileInfo, setFileInfo] = useState(null);
  const [fileInfoApi, setFileInfoApi] = useState(null);
  const [fileInfoApiWs, setFileInfoApiWs] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadOpen, setuploadOpen] = useState(false);
  const [viewFilesClicked, setviewFilesClicked] = useState(false);
  const [openFileUrlClicked, setopenFileUrlClicked] = useState(false);
  const [urlInput, seturlInput] = useState("");
  const [isValid, setIsValid] = useState(true);

  const [activeTab, setActiveTab] = useState("tab2");
  const [openModal, setOpenModal] = useState(false);
  const [tableData, settableData] = useState([]);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    seturlInput(inputValue);

    // const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/;
    const urlPattern =
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
    setIsValid(urlPattern.test(inputValue));
  };

  const rangePresets = [
    {
      label: "Last 7 Days",
      value: [dayjs().add(-7, "d"), dayjs()],
    },
    {
      label: "Last 14 Days",
      value: [dayjs().add(-14, "d"), dayjs()],
    },
    {
      label: "Last 30 Days",
      value: [dayjs().add(-30, "d"), dayjs()],
    },
    {
      label: "Last 60 Days",
      value: [dayjs().add(-60, "d"), dayjs()],
    },
    {
      label: "Last 90 Days",
      value: [dayjs().add(-90, "d"), dayjs()],
    },
    // {
    //   label: 'Last 1 Year',
    //   value: [dayjs().add(-1, 'y'), dayjs()],
    // },
  ];

  const [chatFiles, setchatFiles] = useState([]);
  const buttonRef = useRef(null);
  const [openSuccessModal, setopenSuccessModal] = useState(undefined);
  const [openFailureModal, setopenFailureModal] = useState(undefined);
  const [successFailureMessage, setsuccessFailureMessage] = useState("");
  const [showimgpop, setShowimgpop] = useState(false);
  const [imgURL, setImgURL] = useState({});
  const removeModal = () => {
    setopenSuccessModal(undefined);
    setopenFailureModal(undefined);
  };
  const [steps, setsteps] = useState([]);
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const [chatQuery, setChatQuery] = useState("");
  const [isLoadingChat, setIsLoadingChat] = useState(false);
  const [isLoadingChatCompleted, setisLoadingChatCompleted] = useState(false);

  const [stringWords, setstringWords] = useState("");
  const [ws, setWs] = useState(null);
  const chatLoadingRef = useRef();
  const lastChatRef = useRef();
  const [loadingChat, setloadingChat] = useState(false);

  async function handleChatSend(e) {
    if (chatQuery?.trim() === "") return;
    // e.preventDefault();

    setIsLoadingChat(true);
    setisLoadingChatCompleted(true);
    setloadingChat(true);
    let newChatData1 = [...chatData];
    newChatData1 = newChatData1.filter((item) => item?.type !== "loader");
    let senderDiv = document.createElement("div");
    if (fileInfo) {
      // let fileDiv = document.querySelector(".file-card");
      let fileDiv = fileInfoRef.current?.cloneNode(true);
      fileDiv?.querySelector("button")?.remove();
      senderDiv.appendChild(fileDiv);

      // newChatData1.push({
      //   type: "doc",
      //   message: fileInfo?.path,
      //   timestamp: new Date(),
      // });
    }
    let chatQueryDiv = document.createElement("div");
    chatQueryDiv.innerHTML = getContent(chatQuery?.replaceAll(/\n/g, "<br/>"));
    senderDiv.appendChild(chatQueryDiv);
    newChatData1.push({
      type: "sender",
      message: senderDiv.outerHTML,
      timestamp: new Date(),
    });
    clog(senderDiv, "div");
    let length = newChatData1.length;
    setChatData(newChatData1);

    let localFile = JSON.parse(localStorage.getItem("chat_file"));
    if (!localFile) {
      let fileName = "Untitled Chat";
      let data = {
        thread_folder: getDate(),
        thread_name: fileName,
        thread_id: "",
        chat_time: new Date(),
        chat_type: "ask",
        chat_content: senderDiv.outerHTML,
        thread_type: "general",
      };
    } else {
      clog("fileInfo", fileInfo);
      let data = {
        thread_folder: getDate(),
        thread_name: localFile?.thread_name,
        thread_id: localFile?.thread_id,
        chat_time: new Date(),
        chat_type: "ask",
        chat_content: senderDiv.outerHTML,
        thread_type: "general",
      };
      clog("data", data);
    }

    setChatQuery("");
    // return;

    setFileInfo(null);
    setFileInfoApi(null);
    // Scroll to the bottom

    try {
      let formData = new FormData();
      formData.append("uri", "neo4j://20.232.151.43:7687");
      formData.append("userName", "neo4j");
      formData.append("password", "5MxjSYrNPj448cF");
      formData.append("database", "neo4j");
      formData.append("session_id", "12345");
      formData.append("question", chatQuery);
      formData.append("mode", "graph_vector_fulltext");
      formData.append("model", "openai-gpt-3.5");
      formData.append("document_names", JSON.stringify([])); // Serialize arrays/objects to strings

      let response = await axios({
        method: "POST",
        url: `https://graphrag.dev-vison.infiniticube.in/chat_bot`,
        headers: {
          "Content-Type": "multipart/form-data",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: formData,
      });
      clog(response, "response");
      if (response?.data?.status == "Success") {
        // let newChatData = [...chatData];
        // // newChatData = newChatData.filter((item) => item?.type !== "loader");
        // newChatData.push({
        //   type: "receiver",
        //   message: response?.data?.data?.message,
        //   timestamp: new Date(),
        // });
        // setChatData(newChatData);
        // setloadingChat(false);
        setChatData((prev) => [
          ...prev,
          {
            type: "receiver",
            message: response?.data?.data?.message,
            timestamp: new Date(),
          },
        ]);
        setIsLoadingChat(false);
      } else {
        setloadingChat(false);
        setIsLoadingChat(false);
        setisLoadingChatCompleted(false);
        // setChatData((prev) => prev.filter((item) => item?.type !== "loader"));
        setWs(null);
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      clog(error, "error");
      setloadingChat(false);
      setIsLoadingChat(false);
      setisLoadingChatCompleted(false);
      // setChatData((prev) => prev.filter((item) => item?.type !== "loader"));
      setWs(null);
    }
  }
  clog("chatData", chatData);
  const getChatFileTime = (dateStr) => {
    const formattedDate = moment(dateStr).format("DD MMMM, YYYY | hh:mm A");
    return formattedDate;
  };
  // Function to extract the desired part of the filename
  const extractFilename = (url) => {
    // Split the URL by '/' and get the last part (the filename)
    const ext = url.split(".").pop();
    if (
      ext === "pdf" ||
      ext === "doc" ||
      ext === "docx" ||
      ext === "xls" ||
      ext === "xlsx" ||
      ext === "jpg" ||
      ext === "jpeg" ||
      ext === "png"
    ) {
      const parts = url.split("/");
      const fullFilename = parts[parts.length - 1];

      // Split the filename by '-' and remove the extension
      const [filename] = fullFilename.split("-");

      return filename;
    } else {
      return url;
    }
  };

  const getContent = (message) => {
    const md = new Remarkable();
    md.set({
      html: true,
      breaks: true,
      linkify: true,
      typographer: true,
      quotes: "“”‘’",
      xhtmlOut: true,
    });

    const rendered = md.render(message || "");

    // Wrap code blocks with a div, add language label, and a copy button
    const wrappedCode = rendered.replace(
      /<pre><code class="language-([^"]+)">([\s\S]*?)<\/code><\/pre>/g,
      (match, p1, p2) => {
        // const encodedCode = encodeURIComponent(p2);
        const encodedCode = p2;
        return `
          <div class="code-block">
            <div class="code-header">
              <span class="language-label">${p1}</span>

              <button class="copy-btn" data-code="${encodedCode}">
                <svg class="icon">
                  <use href="#icon_copy"></use>
                </svg>
                Copy code
              </button>
            </div>
            <pre><code class="language-${p1}">${p2}</code></pre>
          </div>
        `;
      }
    );

    return wrappedCode;
  };
  const callDeleteFileApiNode = async (data) => {
    try {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/delete/upload_file`,
        data: data,
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
      });
      clog(response, "response");
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      clog(error, "error");
    }
  };
  const callDeleteFileApiChat = async (data) => {
    try {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/chat/delete`,
        data: data,
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
      });
      clog(response, "response");
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      clog(error, "error");
    }
  };
  const callDeleteFileApiWs = async (data) => {
    let newWs = new WebSocket(
      `${process.env.REACT_APP_CHAT_BASE_URL}/delete_file`
    );
    if (newWs?.readyState == newWs?.OPEN) {
      const dataToSend = JSON.stringify(data);
      newWs.send(dataToSend);
    }
    newWs.onopen = function open() {
      clog("websocket opened");
      const dataToSend = JSON.stringify(data);
      newWs.send(dataToSend);
      clog("sent to websocket on open", dataToSend);
    };
    newWs.onmessage = function incoming(data) {
      const word = data.data;
    };
    newWs.onclose = () => {
      clog("WebSocket connection closed.");
    };
  };
  const postFileApi = async (file) => {
    // return;
    let localFile = JSON.parse(localStorage.getItem("chat_file"));
    let data = {
      file_id: file?.file_id?.toString(),
      file_type: "url",
      file_url: file?.file_path,
      user_id: JSON.parse(
        localStorage.getItem("login_data")
      )?.resp_user?.id?.toString(),
      thread_id: file?.chatres?.thread_id?.toString(),
      file_name: file?.file_name,
    };
    clog(data, "akmal data");

    let newWs = new WebSocket(
      `${process.env.REACT_APP_CHAT_BASE_URL}/doc_insert`
    );

    clog(newWs, "ready state...");
    if (newWs?.readyState == newWs?.OPEN) {
      const dataToSend = JSON.stringify(data);
      newWs.send(dataToSend);
    }
    newWs.onopen = function open() {
      clog("websocket opened");
      const dataToSend = JSON.stringify(data);
      newWs.send(dataToSend);
      clog("sent to websocket on open", dataToSend);
    };

    newWs.onmessage = function incoming(data) {
      const word = data.data;
      const correctedJsonString = word.replace(/'/g, '"');
      const jsonData = JSON.parse(correctedJsonString);
      clog(jsonData, "json data");
      if (jsonData?.status == "successful") {
        setUploading(false);
        setFileInfoApiWs(jsonData);
        setsuccessFailureMessage("Document added successfully");
        setopenSuccessModal("dismissible");
      } else {
        // return;
        setsuccessFailureMessage(jsonData?.message);
        setopenFailureModal("dismissible");
        setUploading(false);
        callDeleteFileApiNode({
          file_path: file?.file_path,
          doc_id: file?.doc_id,
        });
        setFileInfoApiWs(null);
        setChatData((prev) =>
          prev.filter((item) => item?.message != file?.file_path)
        );
        let chatData = JSON.parse(localStorage.getItem("chat_details")) || [];
        chatData = chatData.filter(
          (item) => item?.chat_content != file?.file_path
        );
        localStorage.setItem("chat_details", JSON.stringify(chatData));
        setFileInfo(null);
        setFileInfoApi(null);
        setFileInfoApiWs(null);
      }
    };

    newWs.onclose = () => {
      clog("WebSocket connection closed.");
      setUploading(false);
    };
    newWs.onerror = (error) => {
      console.error("WebSocket error:", error);
      setFileInfoApiWs(null);
      setUploading(false);
      setsuccessFailureMessage(error?.message || "Something went wrong");
      setopenFailureModal("dismissible");
    };
  };
  const generateRandomString = () => {
    return Math.random().toString(36).substring(2, 8);
  };

  const postFileUrlApi = async () => {
    // return;
    setopenFileUrlClicked(false);
    let localFile = JSON.parse(localStorage.getItem("chat_file"));
    let postData = {};
    if (!localFile) {
      let fileName = "Untitled Chat";
      let data = {
        thread_folder: getDate(),
        thread_name: fileName,
        thread_id: "",
        chat_time: new Date(),
        chat_type: "doc",
        chat_content: urlInput,
        thread_type: "general",
      };
      setChatData((prev) => [
        ...prev,
        {
          type: "doc",
          message: urlInput,
          timestamp: data?.chat_time,
        },
      ]);
      postData = {
        file_id: generateRandomString(),
        file_type: "url",
        file_url: urlInput,
        user_id: JSON.parse(
          localStorage.getItem("login_data")
        )?.resp_user?.id?.toString(),
        thread_id: "",
        file_name: "",
      };
      setFileInfo({
        file_id: postData?.file_id,
        file_path: urlInput,
        file_name: "",
        name: urlInput,
        icon: "",
      });
      setFileInfoApi({
        type: "url",
        file_id: postData?.file_id,
        doc_id: "",
        file_path: urlInput,
      });
    } else {
      let data = {
        thread_folder: getDate(),
        thread_name: localFile?.thread_name,
        thread_id: localFile?.thread_id,
        chat_time: new Date(),
        chat_type: "doc",
        chat_content: urlInput,
        thread_type: "general",
      };
      setChatData((prev) => [
        ...prev,
        {
          type: "doc",
          message: urlInput,
          timestamp: data?.chat_time,
        },
      ]);
      postData = {
        file_id: generateRandomString(),
        file_type: "url",
        file_url: urlInput,
        user_id: JSON.parse(
          localStorage.getItem("login_data")
        )?.resp_user?.id?.toString(),
        thread_id: localFile?.thread_id?.toString(),
        file_name: "",
      };
      setFileInfo({
        file_id: postData?.file_id,
        file_path: urlInput,
        file_name: "",
        name: urlInput,
        icon: "",
      });
      setFileInfoApi({
        type: "url",
        file_id: postData?.file_id,
        doc_id: "",
        file_path: urlInput,
      });
    }
    setUploading(true);
    clog(postData, "akmal data");

    let newWs = new WebSocket(
      `${process.env.REACT_APP_CHAT_BASE_URL}/doc_insert`
    );

    clog(newWs, "ready state...");
    if (newWs?.readyState == newWs?.OPEN) {
      const dataToSend = JSON.stringify(postData);
      newWs.send(dataToSend);
    }
    newWs.onopen = function open() {
      clog("websocket opened");
      const dataToSend = JSON.stringify(postData);
      newWs.send(dataToSend);
      clog("sent to websocket on open", dataToSend);
    };

    newWs.onmessage = function incoming(data) {
      const word = data.data;
      const correctedJsonString = word.replace(/'/g, '"');
      const jsonData = JSON.parse(correctedJsonString);
      clog(jsonData, "json data");
      if (jsonData?.status == "successful") {
        setUploading(false);
        setFileInfoApiWs(jsonData);
        setsuccessFailureMessage("URL added successfully");
        setopenSuccessModal("dismissible");
      } else {
        setsuccessFailureMessage(jsonData?.message);
        setopenFailureModal("dismissible");
        setUploading(false);
      }
    };

    newWs.onclose = () => {
      clog("WebSocket connection closed.");
      setUploading(false);
    };
    newWs.onerror = (error) => {
      console.error("WebSocket error:", error);
      setFileInfoApiWs(null);
      setUploading(false);
      setsuccessFailureMessage(error?.message || "Something went wrong");
      setopenFailureModal("dismissible");
    };
  };
  const [domainList, setdomainList] = useState({});
  const [domainLoading, setdomainLoading] = useState(false);
  const getDomainList = async () => {
    setdomainLoading(true);
    try {
      const selectedWorkspace = JSON.parse(
        localStorage.getItem("selected_workspace") || "{}"
      );
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/domain`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        params: {
          workspace_id: selectedWorkspace?.workspace_id || null,
        },
      });
      if (!response.data.error) {
        setdomainList(response?.data?.data || {});
      } else {
        clog("Error in fetching notifications");
        setdomainList({});
      }
      setdomainLoading(false);
    } catch (error) {
      clog("Error in fetching notifications", error);
      setdomainList({});
      if (error?.response?.status == 401 || error?.response?.status == 403) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      setdomainLoading(false);
    }
  };

  useEffect(() => {
    // Scroll to the last point of the container
    if (chatLoadingRef.current) {
      const container = chatLoadingRef.current;
      const lastElement = container?.lastElementChild;
      lastElement?.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [chatData, chatData.length, lastChatRef]);
  useEffect(() => {
    setmounted(false);
  }, [location.search]);
  // useEffect(() => {
  //   if (localStorage.getItem("chat_details")) {
  //     let chatData = JSON.parse(localStorage.getItem("chat_details")) || [];
  //     if (chatData?.length == 0) {
  //       setChatData([]);
  //       return;
  //     }
  //     if (mounted) {
  //       return;
  //     }
  //     let modifiedChatData = chatData?.map((item) => {
  //       const getChatType = (type) => {
  //         if (type == "ask") {
  //           return "sender";
  //         } else if (type == "ans") {
  //           return "receiver";
  //         } else if (type == "doc") {
  //           return "doc";
  //         } else {
  //           return "loader";
  //         }
  //       };
  //       return {
  //         type: getChatType(item?.chat_type),
  //         message: item?.chat_content,
  //         timestamp: item?.chat_time,
  //         file_name: item?.file_name,
  //       };
  //     });
  //     setChatData(modifiedChatData);
  //   }
  // }, [location.search, mounted]);

  useEffect(() => {
    setWs(null);
  }, [location.search]);

  useEffect(() => {
    if (!reporting) {
      setActiveTab("tab3");
      getDomainList();
    }
  }, []);
  const isToday = (date) => {
    const today = moment().format("DD-MM-YYYY");
    return today == date;
  };
  const isYesterday = (date) => {
    const yesterday = moment().subtract(1, "days").format("DD-MM-YYYY");
    return yesterday == date;
  };

  const getChatDates = () => {
    let chatDates = [];
    for (let i = 0; i < chatData.length; i++) {
      let date = moment(chatData[i].timestamp).format("DD-MM-YYYY");
      if (chatDates.indexOf(date) == -1) {
        chatDates.push(date);
      }
    }
    return chatDates;
  };
  const getChatsData = (date) => {
    let chatsData = [];
    for (let i = 0; i < chatData.length; i++) {
      let dateChat = moment(chatData[i].timestamp).format("DD-MM-YYYY");
      if (dateChat == date) {
        chatsData.push(chatData[i]);
      }
    }
    return chatsData;
  };
  const getDayOfWeek = (date) => {
    let dateString;
    if (isToday(date)) {
      dateString = "Today";
    } else if (isYesterday(date)) {
      dateString = "Yesterday";
    } else {
      dateString = date;
    }
    return dateString;
  };
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const maxFileSize = 2 * 1024 * 1024; // 2MB
    if (file) {
      if (file.size > maxFileSize) {
        setuploadOpen(false);
        setsuccessFailureMessage("Please upload a file less than 2MB");
        setopenFailureModal("dismissible");
        return;
      }
      setUploading(true);
      setFileInfo({
        name: file.name,
        icon: "",
        file: file,
        ext: "",
      });
      setviewFilesClicked(false);
      uploadFileToBlobStorage(file);
      setuploadOpen(false);
    }
    event.target.value = "";
  };
  const removeFile = async () => {
    if (fileInfoApi?.type && fileInfoApi?.type == "url") {
      callDeleteFileApiWs({ file_id: fileInfoApi?.file_id?.toString() });
      callDeleteFileApiChat({
        doc_id: fileInfoApi?.doc_id,
      });
    } else {
      callDeleteFileApiNode({
        file_path: fileInfoApi?.file_path,
        doc_id: fileInfoApi?.doc_id,
      });
      callDeleteFileApiWs({ file_id: fileInfoApi?.file_id?.toString() });
    }
    setChatData((prev) =>
      prev.filter((item) => item?.message != fileInfoApi?.file_path)
    );
    let chatData = JSON.parse(localStorage.getItem("chat_details")) || [];
    chatData = chatData.filter(
      (item) => item?.chat_content != fileInfoApi?.file_path
    );
    localStorage.setItem("chat_details", JSON.stringify(chatData));
    setFileInfo(null);
    setFileInfoApi(null);
    setFileInfoApiWs(null);
  };
  clog(fileInfoApi, "fileInfoApi");

  const uploadFileToBlobStorage = async (file) => {
    clog(file, "file upload");
    // return;
    const formData = new FormData();
    formData.append("vsn_file", file);
    let localFile = JSON.parse(localStorage.getItem("chat_file"));
    let global_file_name = "";
    if (!localFile) {
      let fileName = "Untitled Chat";
      global_file_name = fileName;
      formData.append("thread_name", fileName);
      formData.append("thread_id", "");
    } else {
      global_file_name = localFile?.thread_name;
      formData.append("thread_name", localFile?.thread_name);
      formData.append("thread_id", localFile?.thread_id);
    }

    try {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/upload/files/chatfile`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          jwt_token: localStorage.getItem("login_token"),
        },
      });

      if (!response?.data?.error) {
        const data = response.data;
        postFileApi(data, global_file_name);
        if (!localFile) {
          localStorage.setItem(
            "chat_file",
            JSON.stringify({
              thread_name: global_file_name,
              thread_id: data?.chatres?.thread_id,
            })
          );
        }
        setChatData((prev) => [
          ...prev,
          {
            type: "doc",
            message: data?.chatres?.chat_content,
            timestamp: data?.chatres?.chat_time,
            file_name: file?.name,
          },
        ]);
        let chatData = JSON.parse(localStorage.getItem("chat_details")) || [];
        chatData.push({
          chat_content: data?.chatres?.chat_content,
          chat_time: data?.chatres?.chat_time,
          chat_type: "doc",
          thread_name: global_file_name,
          thread_id: data?.chatres?.thread_id,
          _id: data?.chatres?._id,
          file_name: file?.name,
        });
        localStorage.setItem("chat_details", JSON.stringify(chatData));
        clog("data", data);
        setFileInfo((prev) => ({ ...prev, path: data.file_path }));
        setFileInfoApi(data);
      } else {
        setsuccessFailureMessage(response.message);
        setFileInfo(null);
        setFileInfoApi(null);
        setUploading(false);
        setopenFailureModal("dismissible");
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      setUploading(false);
      setFileInfo(null);
      setFileInfoApi(null);
      console.error("Upload failed:", error);
      setsuccessFailureMessage(error?.message);
      setopenFailureModal("dismissible");
    }
  };
  const getFilesFromChat = () => {
    let files = [];
    for (let i = 0; i < chatData?.length; i++) {
      if (chatData[i]?.type == "doc") {
        files.push(chatData[i]);
      }
    }
    setchatFiles(files);
  };
  // clog("chatData", chatData);
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset the height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set to scroll height
    }
    if (viewFilesRef.current && textareaRef.current) {
      let height = Math.min(textareaRef.current.scrollHeight, 280) + 60;
      viewFilesRef.current.style.bottom = `${height}px`; // Adjust the position of view files section
    }
  }, [chatQuery, viewFilesClicked]);
  useEffect(() => {
    const handleCopyButtonClick = (e) => {
      if (e.target.classList.contains("copy-btn")) {
        const code = decodeURIComponent(e.target.getAttribute("data-code"));
        const textarea = document.createElement("textarea");
        textarea.value = code;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        alert("Code copied to clipboard!");
      }
    };

    document.body.addEventListener("click", handleCopyButtonClick);

    return () => {
      document.body.removeEventListener("click", handleCopyButtonClick);
    };
  }, []);
  const handleClickOutside = (event) => {
    if (buttonRef.current && !buttonRef.current.contains(event.target)) {
      setuploadOpen(false);
    }
  };

  useEffect(() => {
    if (uploadOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [uploadOpen]);
  // useEffect(() => {
  //   return () => {
  //     if (ws) {
  //       ws.close();
  //     }
  //   };
  // }, [ws]);
  clog(fileInfo, "fileInfo");
  clog(chatFiles, "chatFiles");

  // tabl
  const columns = [
    {
      title: "Keywords",
      dataIndex: "keys",
      align: "center",
      sorter: (a, b) => a.keys.localeCompare(b.keys),
    },
    {
      title: "Search Engine",
      dataIndex: "searchengine",
      align: "center",
    },
    {
      title: "Avg Position",
      dataIndex: "position",
      align: "center",
      sorter: (a, b) => a.position - b.position,
    },
    {
      title: "Impressions",
      dataIndex: "impressions",
      align: "center",
      sorter: (a, b) => a.impressions - b.impressions,
    },
    {
      title: "Clicks",
      dataIndex: "clicks",
      align: "center",
      sorter: (a, b) => a.clicks - b.clicks,
    },
    {
      title: "CTR",
      dataIndex: "ctr",
      align: "center",
      render: (text) => `${(text * 100).toFixed(2)}%`,
      sorter: (a, b) => a.ctr - b.ctr,
    },
    // {
    //   title: 'VisibilityGain/Loss',
    //   dataIndex: 'gainloss',
    //   align: 'center',
    //   render: (text) => {
    //     const value = parseFloat(text.replace('%', '')); // Remove '%' and convert to number
    //     const backgroundColor = value > 0 ? '#20C217' : value < 0 ? '#E2321A' : 'lightgray';

    //     return (
    //       <span
    //         style={{
    //           backgroundColor,
    //           color: 'white', // Text color white
    //           fontWeight: 'bold', // Make text bold
    //           padding: '4px 8px',
    //           borderRadius: '4px',
    //           display: 'inline-block', // Ensure proper spacing
    //           minWidth: '50px', // Consistent size
    //           textAlign: 'center',
    //         }}
    //       >
    //         {text}
    //       </span>
    //     );
    //   },
    // },
  ];
  const data = [
    {
      key: "1",
      name: "John Brown",
      keys: "Lorem ipsum",
      searchengine: "Google",
      avgposition: "Google",
      impressions: 20,
      count: 20,
      clicks: 20,
      ctr: "20%",
      // gainloss: '20%',
    },
    {
      key: "2",
      name: "John Brown",
      keywords: "Lorem ipsum",
      searchengine: "Google",
      avgposition: "Google",
      impressions: 20,
      count: 20,
      clicks: 20,
      ctr: "20%",
      // gainloss: "-10%",
    },
  ];
  const onChange = (pagination, filters, sorter, extra) => {
    clog("params", pagination, filters, sorter, extra);
  };
  // tabl
  const { token } = theme.useToken();
  const style = {
    border: `1px solid ${token.colorPrimary}`,
    borderRadius: "50%",
  };
  const [loadingWebsiteData, setloadingWebsiteData] = useState(false);
  const [loadingUserActivityData, setloadingUserActivityData] = useState(false);
  const [loadingUserIdJourney, setloadingUserIdJourney] = useState(false);
  const getTableData = async () => {
    // if (
    //   !wordPressDetails ||
    //   Object.keys(wordPressDetails || {})?.length === 0 ||
    //   !wordPressDetails?.domain
    // ) {
    //   return;
    // }
    try {
      setloadingWebsiteData(true);
      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/google/webmaster/data`,
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          website: localStorage.getItem("gsc_website"),
          start_date: fromDate ? fromDate?.format("YYYY-MM-DD") : null,
          end_date: toDate ? toDate?.format("YYYY-MM-DD") : null,
        },
      });
      clog(response, "response");
      if (!response?.data?.error) {
        let keywordsData = response?.data?.query;
        if (keywordsData) {
          keywordsData = keywordsData.map((item, index) => {
            return {
              key: index + 1,
              keys: item?.keys[0],
              searchengine: item?.searchengine || "Google",
              position: item?.position,
              impressions: item?.impressions,
              clicks: item?.clicks,
              ctr: item?.ctr,
            };
          });
        }
        let pages = response?.data?.pages;
        if (pages) {
          pages = pages.map((item, index) => {
            return {
              key: index + 1,
              keys: item?.keys[0],
              searchengine: item?.searchengine || "Google",
              position: item?.position,
              impressions: item?.impressions,
              clicks: item?.clicks,
              ctr: item?.ctr,
            };
          });
        }
        setrankingData({
          keywordsData: keywordsData,
          pages: pages,
        });
      } else {
        setrankingData({});
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      clog(error, "error");
    } finally {
      setloadingWebsiteData(false);
    }
  };
  const getUserActivityData = async () => {
    // This function now only fetches graph data (not user list)
    // User list is fetched via loadMoreData with pagination
    try {
      const selectedWorkspace = JSON.parse(
        localStorage.getItem("selected_workspace") || "{}"
      );
      setloadingUserActivityData(true);
      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/analytics/report`,
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          from_date: fromDateUserJ ? fromDateUserJ?.format("YYYY-MM-DD") : null,
          to_date: toDateUserJ ? toDateUserJ?.format("YYYY-MM-DD") : null,
          workspace_id: selectedWorkspace?.workspace_id || null,
          offset: 0,
          limit: 1, // Only need graph data, so minimal limit
        },
      });
      clog(response, "response");
      if (!response?.data?.error) {
        setUserActivityData({
          userList: [], // Don't store all data client-side
          graphData: response?.data?.graphdata || [],
        });
      } else {
        setUserActivityData({
          userList: [],
          graphData: [],
        });
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      clog(error, "error");
    } finally {
      setloadingUserActivityData(false);
    }
  };
  const getUserIdJourney = async (ip_address) => {
    try {
      const selectedWorkspace = JSON.parse(
        localStorage.getItem("selected_workspace") || "{}"
      );
      setloadingUserIdJourney(true);
      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/analytics/report/details`,
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          user_uniq_id: ip_address || null,
          workspace_id: selectedWorkspace?.workspace_id || null,
        },
      });
      clog(response, "response");
      if (!response?.data?.error) {
        let data = [];

        if (response?.data?.data) {
          //need to merge all the data object of same session_id into one object of session_id as key and array of objects as value

          /*
            like this 
            [
            {
              "session_id": "1",
              "1": [
                  { 
                    ...data
                  },
                  { 
                    ...data
                  }
              ]
            },
             {
              "session_id": "2",
              "2": [
                  { 
                    ...data
                  },
                  { 
                    ...data
                  }
              ]
            }
            ]
          */
          let dataObj = {};
          // response?.data?.data.forEach((item) => {
          //   if (dataObj[item?.session_id]) {
          //     dataObj[item?.session_id].push(item);
          //   } else {
          //     dataObj[item?.session_id] = [item];
          //   }
          // });
          response?.data?.userjourney?.forEach((item) => {
            if (dataObj[item?.session_id]) {
              dataObj[item?.session_id].push(item);
            } else {
              dataObj[item?.session_id] = [item];
            }
          });

          data = Object.keys(dataObj).map((key) => {
            return {
              session_id: key,
              data: dataObj[key],
            };
          });
        }

        clog(data, "data");

        setUserIdJourneyData(data);
      } else {
        setUserIdJourneyData({});
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      clog(error, "error");
    } finally {
      setloadingUserIdJourney(false);
    }
  };
  const getLatestUpdatedAt = (data) => {
    if (data?.length > 0) {
      let latestDate = data[0]?.updatedAt;
      for (let i = 1; i < data?.length; i++) {
        if (moment(data[i]?.updatedAt).isAfter(latestDate)) {
          latestDate = data[i]?.updatedAt;
        }
      }
      return latestDate;
    }
    return null;
  };
  useEffect(() => {
    // getTableData();
  }, [toDate, fromDate]);
  // useEffect(() => {
  //   // Reset pagination and fetch data when date filters change
  //   const initializeData = async () => {
  //     setOffset(0);
  //     setUserList([]);
  //     // Load initial user list with pagination (this also fetches graph data on initial load)
  //     await loadMoreData(0, true);
  //   };
  //   initializeData();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [toDateUserJ, fromDateUserJ]);

  const formatTimeLabel = (data, date) => {
    let isDateSame =
      moment(data?.at(0)?.createdAt).format("DD-MM-YYYY") ==
      moment(data?.at(-1)?.createdAt).format("DD-MM-YYYY");
    if (isDateSame) {
      return moment(date).format("hh:mm A");
    }
    return moment(date).format("DD/MM/YYYY hh:mm A");
  };
  const [userList, setUserList] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const observerRef = useRef();
  const limit = 10; // Items per page

  // Load initial data when component mounts or date filters change
  const prevFilters = useRef({
    toDateUserJ,
    fromDateUserJ,
    sessionType,
    toDateUserK,
    fromDateUserK
  });
  const isInitialLoad = useRef(true);

  useEffect(() => {
    let filter_type = null;

    if (isInitialLoad.current) {
      isInitialLoad.current = false;
    } else {
      const hasFilter1Changed =
        toDateUserJ !== prevFilters.current.toDateUserJ ||
        fromDateUserJ !== prevFilters.current.fromDateUserJ;

      const hasFilter2Changed =
        sessionType !== prevFilters.current.sessionType ||
        toDateUserK !== prevFilters.current.toDateUserK ||
        fromDateUserK !== prevFilters.current.fromDateUserK;

      if (hasFilter1Changed) {
        filter_type = 1;
      } else if (hasFilter2Changed) {
        filter_type = 2;
      }
    }

    prevFilters.current = {
      toDateUserJ,
      fromDateUserJ,
      sessionType,
      toDateUserK,
      fromDateUserK
    };

    // Reset pagination when date filters change only if filter_type is not 1
    if (filter_type != 1) {
      setOffset(0);
      setUserList([]);
    }
    loadMoreData(0, true, filter_type);
  }, [toDateUserJ, fromDateUserJ, sessionType, toDateUserK, fromDateUserK]);

  // Load more data function - now fetches from backend
  const loadMoreData = async (currentOffset = offset, isInitialLoad = false, filter_type = null, currentSessionType = sessionType) => {
    if (loading) return;
    setLoading(true);

    try {
      const selectedWorkspace = JSON.parse(
        localStorage.getItem("selected_workspace") || "{}"
      );

      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/analytics/report`,
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          from_date: filter_type == 1 ? fromDateUserJ ? fromDateUserJ?.format("YYYY-MM-DD") : null : fromDateUserK ? fromDateUserK?.format("YYYY-MM-DD") : null,
          to_date: filter_type == 1 ? toDateUserJ ? toDateUserJ?.format("YYYY-MM-DD") : null : toDateUserK ? toDateUserK?.format("YYYY-MM-DD") : null,
          workspace_id: selectedWorkspace?.workspace_id || null,
          offset: currentOffset,
          lead_identity: currentSessionType,
          limit: limit,
          filter_type: filter_type
        },
      });

      if (!response?.data?.error) {
        let userlist = response?.data?.data || [];

        // Filter out duplicates based on _id
        userlist = userlist.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t._id === item._id)
        );

        userlist = userlist.map((item, index) => {
          if (item?.user_uniq_id) {
            return item;
          } else {
            return {
              ...item,
              user_uniq_id: uuidV5(item?._id, NAMESPACE),
            };
          }
        });

        // Update graph data only on initial load and filter type is 1 or null
        if (isInitialLoad && filter_type != 2) {
          setUserActivityData({
            userList: [], // Don't store all data client-side anymore
            graphData: response?.data?.graphdata || [],
          });
        }

        // only if filter type is 2 or null and skip if 1 
        if (filter_type != 1) {
          setUserList((prev) => {
            const combinedData = [...prev, ...userlist];
            // Filter out duplicates based on _id
            const uniqueData = combinedData.filter(
              (item, index, self) =>
                index === self.findIndex((t) => t._id === item._id)
            );
            return uniqueData;
          });

          // Update pagination state
          const pagination = response?.data?.pagination || {};
          setHasNextPage(pagination.hasNextPage || false);
          setTotalCount(pagination.totalCount || 0);
          setOffset(currentOffset + userlist.length);
        }
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      clog(error, "error");
    } finally {
      setLoading(false);
    }
  };

  // Intersection Observer for infinite scroll
  const observerState = useRef({ hasNextPage, loading, offset, sessionType });
  useEffect(() => {
    observerState.current = { hasNextPage, loading, offset, sessionType };
  }, [hasNextPage, loading, offset, sessionType]);

  const loadMoreTriggerRef = React.useCallback((node) => {
    if (observerRef.current) observerRef.current.disconnect();

    observerRef.current = new IntersectionObserver((entries) => {
      const state = observerState.current;
      if (entries[0].isIntersecting && state.hasNextPage && !state.loading) {
        loadMoreData(state.offset, false, 2, state.sessionType);
      }
    });

    if (node) observerRef.current.observe(node);
  }, []);

  return (
    <>
      {/* <div className="w-full flex flex-wrap -mx-4 px-1">
        <div
          className={`w-[100%] h-[75%]  ${
            displayEditor && "md:w-1/2  border-r "
          } px-4 pb-2 relative`}
          style={{
            height: "calc(100vh - 150px)",
            display: !fullscreenClicked ? "block" : "none",
          }}
        >
          <div className={`overflow-auto h-[74%]`}>
            {getChatDates()?.map((date, date_index, date_arr) => (
              <>
                <div className="title title--center-line flex font-normal text-[12px] my-2">
                  {getDayOfWeek(date)}
                </div>
                <div ref={chatLoadingRef}>
                  {getChatsData(date)?.map((chat, chat_index) => {
                    if (chat?.type == "sender") {
                      return (
                        <div
                          className="pb-2 sender"
                          ref={
                            chat_index === chatData.length - 1
                              ? lastChatRef
                              : undefined
                          }
                        >
                          <div className="flex justify-end">
                            <div
                              className="max-w-[75%] bg-[#FAFBFC] py-[8px] px-[12px] rounded-tr-[15px] rounded-l-[15px] text-[14px] font-semibold pt-[0.5em] pb-[0.5em]"
                              data-time={moment(chat?.timestamp).format(
                                "h:mm A"
                              )}
                              dangerouslySetInnerHTML={{
                                __html: chat?.message,
                              }}
                            />
                          </div>
                          <div className="flex">
                            <p className="ms-auto text-[10px] font-semibold pt-1">
                              {moment(chat?.timestamp).format("h:mm A")}
                            </p>
                          </div>
                        </div>
                      );
                    } else if (chat?.type == "receiver") {
                      return (
                        <div
                          className="pb-2 receiver"
                          ref={
                            chat_index === chatData.length - 1
                              ? lastChatRef
                              : undefined
                          }
                        >
                          <div className="flex justify-start">
                            <div
                              className="w-[75%] bg-[#F2FAFF] py-[8px] px-[12px] rounded-tl-[15px] rounded-r-[15px] text-[14px] font-semibold text-editor"
                              data-time={moment(chat?.timestamp).format(
                                "h:mm A"
                              )}
                              dangerouslySetInnerHTML={{
                                __html: getContent(chat?.message || ""),
                              }}
                            />
                          </div>
                          <div className="flex w-[75%]">
                            <p className="me-auto text-[10px] font-semibold pt-1">
                              {moment(chat?.timestamp).format("h:mm A")}
                            </p>
                            <p>
                              <button
                                data-tooltip-id="pencil"
                                data-tooltip-content="Copy to Editor"
                                type="button"
                                onClick={() => {
                                  setdisplayEditor(true);
                                  setstringWords(chat?.message);
                                }}
                              >
                                <svg className="icon">
                                  <use href="#icon_pencil"></use>
                                </svg>
                              </button>
                            </p>
                          </div>
                        </div>
                      );
                    } else if (chat?.type == "error") {
                      return (
                        <div
                          className="pb-2 receiver"
                          ref={
                            chat_index === chatData.length - 1
                              ? lastChatRef
                              : undefined
                          }
                        >
                          <div className="flex justify-start">
                            <div className="w-[70%]  py-[8px] px-[12px] rounded-tl-[15px] rounded-r-[15px] text-[14px] font-semibold text-[red]">
                              {chat?.message}
                            </div>
                          </div>
                        </div>
                      );
                    } else if (chat?.type == "loader") {
                      return (
                        <div
                          className="pb-2 receiver"
                          ref={
                            chat_index === chatData.length - 1
                              ? lastChatRef
                              : undefined
                          }
                        >
                          <div className="flex justify-start">
                            <div className="py-[8px] px-[12px] rounded-tl-[15px] rounded-r-[15px] text-[14px] font-semibold text-[red]">
                              <ThreeDotsLoader />
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
                  {isLoadingChat && date_arr.length - 1 === date_index && (
                    <div className="pb-2 receiver">
                      <div className="flex justify-start">
                        <div className="py-[8px] px-[12px] rounded-tl-[15px] rounded-r-[15px] text-[14px] font-semibold text-[red]">
                          <ThreeDotsLoader />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </>
            ))}
          </div>
          <div className="h-[25%] mt-4">
            <div className="w-full chat-field bg-[#FAFBFC] rounded-[15px] p-[8px] absolute bottom-0 border border-[#E9EBF0] z-40">
              <div className="bg-[#fff] rounded-[15px]">
                {fileInfo && (
                  <div
                    ref={fileInfoRef}
                    className="file-card flex items-center border mb-4 border-[#E9EBF0] rounded-[10px] p-[8px] mr-2 relative chatfile-div"
                  >
                    <div className="flex items-center ">
                      {uploading ? (
                        <div className="loader_file mr-2"></div>
                      ) : (
                        <>
                          <img
                            src={fileInfo?.icon}
                            className="w-[34px] me-3"
                            alt="doc"
                          />
                        </>
                      )}
                      <span>{fileInfo?.name}</span>
                    </div>
                    {fileInfo?.link && (
                      <a
                        href={fileInfo?.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ml-2"
                      >
                        Download
                      </a>
                    )}
                    {!uploading && (
                      <button
                        type="button"
                        className="remove-file absolute justify-center items-center right-[5px] p-1"
                        onClick={removeFile}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-gray-400 hover:text-gray-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    )}
                  </div>
                )}
                <div className="relative">
                  <textarea
                    ref={textareaRef}
                    className="w-full min-h-[64px] h-[auto] m-0 rounded-[15px] custom-textarea"
                    placeholder="Enter your question here..."
                    id="textofComment"
                    value={chatQuery}
                    onChange={(e) => {
                      setuploadOpen(false);
                      setChatQuery(e.target.value);
                    }}
                    style={{
                      resize: "none",
                      maxHeight: "280px",
                      overflow: "auto",
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        handleChatSend();
                      }
                    }}
                    onMouseDown={() => {
                      setuploadOpen(false);
                    }}
                  ></textarea>
                  {!uploadOpen && (
                    <button
                      type="button"
                      className={`sendbtn w-[34px] h-[34px] absolute flex justify-center items-center top-[16px] right-[16px] cursor-pointer border-none text-white rounded-full bg-[#4158D0] transition duration-700 ease-in-out`}
                      title="Send"
                      id="sendComment"
                      disabled={isLoadingChatCompleted}
                      onClick={() => {
                        if (chatQuery?.trim()?.length == 0) {
                          return;
                        }
                        handleChatSend();
                      }}
                    >
                      <svg className="icon">
                        <use href="#icon_send"></use>
                      </svg>
                    </button>
                  )}
                </div>
                <div className="flex items-center justify-between px-2 py-4 border-t-[1px] border-[#ECECEC] relative">
                  <button
                    type="button"
                    className="py-2 invisible rounded-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75 flex items-center justify-center w-[212px]"
                    disabled
                  >
                    <svg className="icon me-2 text-[20px]">
                      <use href="#icon_prompts"></use>
                    </svg>
                    <span>Browse Prompts</span>
                  </button>
                  <div ref={buttonRef}>
                    <button
                      type="button"
                      className="py-2 rounded-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75 flex items-center justify-center w-[212px]"
                      onClick={() => {
                        setIsOpen(true);
                      }}
                    >
                      <span>Show dashboard</span>
                    </button>
                    {uploadOpen && (
                      <div className="absolute right-[10px] bottom-[80px] z-10">
                        <input
                          id="file-upload"
                          type="file"
                          className="hidden"
                          accept=".pdf,.doc,.docx,"
                          onChange={handleFileUpload}
                        />
                        <label
                          htmlFor="file-upload"
                          className="cursor-pointer py-2 rounded-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75 flex items-center justify-center w-[212px] mb-4"
                        >
                          <svg className="icon me-2 text-[20px]">
                            <use href="#icon_uploadchat"></use>
                          </svg>
                          <span>Upload Files</span>
                        </label>
                        <button
                          type="button"
                          className="py-2 rounded-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75 flex items-center justify-center w-[212px]"
                          onClick={() => {
                            getFilesFromChat();
                            setviewFilesClicked(true);
                            setuploadOpen(false);
                          }}
                        >
                          <svg className="icon me-2 text-[20px]">
                            <use href="#icon_view"></use>
                          </svg>
                          <span>View Files</span>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {viewFilesClicked && (
              <div
                ref={viewFilesRef}
                className="absolute left-0 rounded-[15px] bottom-[140px] w-full shadow drop-shadow-2xl bg-[#fff] z-0 pb-[40px]"
              >
                <div
                  className="flex px-4 pt-4"
                  onClick={() => {
                    setviewFilesClicked(false);
                    setuploadOpen(false);
                    setopenFileUrlClicked(false);
                  }}
                >
                  <button type="button" className="ms-auto hover:text-[red]">
                    <svg className="icon text-[32px]">
                      <use href="#icon_close"></use>
                    </svg>
                  </button>
                </div>
              </div>
            )}
            {openFileUrlClicked && (
              <div
                ref={viewFilesRef}
                className="absolute left-4 rounded-[15px] bottom-[140px] w-full shadow drop-shadow-2xl bg-[#fff] z-0 pb-[40px]"
              >
                <div
                  className="flex px-4 pt-4"
                  onClick={() => {
                    setopenFileUrlClicked(false);
                    setuploadOpen(false);
                  }}
                >
                  <button type="button" className="ms-auto hover:text-[red]">
                    <svg className="icon text-[32px]">
                      <use href="#icon_close"></use>
                    </svg>
                  </button>
                </div>
                <h4 className="text-[20px] font-semibold pb-2 px-4">
                  Add Open Link / URL
                </h4>
                <p className="my-2 px-4">
                  Please provide an open URL, such as a blog, article, or news
                  piece, that doesn't require a login to view the content.
                </p>
                <div className="overflow-y-auto max-h-[200px] px-4 my-4">
                  <input
                    type="text"
                    className="w-full h-[40px] border-[1px] border-[#E9EBF0] rounded-full px-4 my-2"
                    placeholder="Enter URL"
                    value={urlInput}
                    onChange={handleChange}
                  />
                  {!isValid && (
                    <p className="text-red-500">Please enter a valid URL.</p>
                  )}
                  <div
                    className="my-4 flex justify-end"
                    onClick={() => {
                      if (!urlInput?.trim()) {
                        return;
                      }
                      postFileUrlApi();
                    }}
                  >
                    <button
                      type="button"
                      disabled={uploading}
                      className="py-2 rounded-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75 flex items-center justify-center w-[212px]"
                    >
                      <div></div>
                      <div>{!uploading ? "Submit" : "Submitting"}</div>
                      <div className="">{uploading && <ThreeDotsLoader />}</div>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div> */}
      <div className="flex w-full">
        {reporting && (
          <div className="w-[20%] p-2 asideTabs">
            <div className="tabs-btn">
              {/* <button
              className={`p-2 ${
                activeTab === "tab1"
                  ? "text-[#097BA9] bg-[#E9F2FF] rounded-lg w-full py-[6px] px-2 text-[18px] font-[600] text-left"
                  : "tab-btn hover:bg-[#E9F2FF] rounded-lg w-full py-[6px] px-2 text-[18px] font-[600] text-left"
              }`}
              onClick={() => setActiveTab("tab1")}
            >
              <svg className="icon me-2">
                <use href="#icon_bill"></use>
              </svg>
              Traffic & Engagement
            </button> */}

              {reporting ? (
                <button
                  className={`p-2 ${activeTab === "tab2"
                    ? "text-[#097BA9] bg-[#E9F2FF] rounded-lg w-full py-[6px] px-2 text-[18px] font-[600] text-left"
                    : "tab-btn hover:bg-[#E9F2FF] rounded-lg w-full py-[6px] px-2 text-[18px] font-[600] text-left"
                    }`}
                  onClick={() => setActiveTab("tab2")}
                >
                  <svg className="icon me-2">
                    <use href="#icon_integration"></use>
                  </svg>
                  Rankings & Opportunities
                </button>
              ) : (
                <button
                  className={`p-2 ${activeTab === "tab3"
                    ? "text-[#097BA9] bg-[#E9F2FF] rounded-lg w-full py-[6px] px-2 text-[18px] font-[600] text-left"
                    : "tab-btn hover:bg-[#E9F2FF] rounded-lg w-full py-[6px] px-2 text-[18px] font-[600] text-left"
                    }`}
                  onClick={() => setActiveTab("tab3")}
                >
                  <svg className="icon me-2">
                    <use href="#icon_integration"></use>
                  </svg>
                  User Journey
                </button>
              )}
            </div>
          </div>
        )}

        <div
          className={
            reporting ? "w-[80%] p-5 content-area !overflow-visible" : "w-full p-5 content-area !overflow-visible"
          }
          style={{
            marginLeft: !reporting && "-20px",
            width: !reporting && "100%",
          }}
        >
          {/* {activeTab === "tab1" && (
            <div>
              <h4 className="pb-4 text-[24px] font-[700]">
                Traffic & Engagement
              </h4>
            </div>
          )} */}

          {activeTab === "tab2" && (
            <div>
              {!localStorage.getItem("google_search_console_access") ? (
                <>
                  <div className="flex mb-2">
                    <h4 className="pb-4 text-[24px] font-[700]">Ranking</h4>
                  </div>
                  <div className="text-center">
                    <h2 className="pb-4 text-[24px] font-[700]">
                      You have not connected your website
                    </h2>
                    <button
                      className="bg-gradient-to-r border border-[#000000] hover:border-[transparent] hover:bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-[#fff] h-[40px] w-[200px] rounded-full transition-all duration-300 hover:border-l-0 hover:border-r-0 text-[18px] font-[500]"
                      onClick={() => navigate("/integration-marketing")}
                    >
                      Connect
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex mb-2">
                    <div>
                      <h4 className="pb-4 text-[24px] font-[700]">Ranking</h4>
                      <h4 className="pb-4 text-[20px] font-[500] pb-2">
                        Top Keywords ({rankingData?.keywordsData?.length || 0})
                      </h4>
                    </div>
                    <div className="ms-auto">
                      <div className="mb-3">
                        <DatePicker.RangePicker
                          presets={rangePresets}
                          allowClear={false}
                          className="py-2"
                          value={[fromDate, toDate]}
                          format={"DD MMM YYYY"}
                          onChange={(dates) => {
                            setFromDate(dates?.length ? dates[0] : "");
                            setToDate(dates?.length ? dates[1] : "");
                          }}
                        />
                      </div>
                      {/* <div className="flex">
                        <select
                          className="rounded-lg ms-auto"
                          name="search"
                          id="search"
                          disabled
                        >
                          <option value="google">Google</option>
                          <option value="Yahoo">Yahoo</option>
                        </select>
                      </div> */}
                    </div>
                  </div>
                  {loadingWebsiteData && (
                    // Skeleton table for Website Ranking data
                    <div className="pb-4">
                      <div className="h-6 w-48 bg-gray-300 rounded skeleton-wave mb-4"></div>
                      <div className="border rounded-lg shadow-md overflow-hidden bg-white">
                        {/* Table header skeleton */}
                        <div className="grid grid-cols-5 gap-3 px-4 py-3 border-b border-[#E9EBF0] bg-[#FAFBFC]">
                          {[...Array(5)].map((_, index) => (
                            <div
                              key={index}
                              className="h-4 w-24 bg-gray-300 rounded skeleton-wave"
                            ></div>
                          ))}
                        </div>
                        {/* Table rows skeleton */}
                        <div className="divide-y divide-[#F5F5F5]">
                          {[...Array(5)].map((_, rowIndex) => (
                            <div
                              key={rowIndex}
                              className="grid grid-cols-5 gap-3 px-4 py-3"
                            >
                              {[...Array(5)].map((_, colIndex) => (
                                <div
                                  key={colIndex}
                                  className="h-4 w-full bg-gray-300 rounded skeleton-wave"
                                ></div>
                              ))}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                  {!loadingWebsiteData && (
                    <Table
                      className="border rounded-lg shadow-md"
                      columns={columns}
                      dataSource={rankingData?.keywordsData || []}
                      onChange={onChange}
                      pagination={{ pageSize: 5 }} // Display 5 rows per page
                    />
                  )}
                  <div className="flex mt-2">
                    <div>
                      <h4 className="pb-4 text-[20px] font-[500] pb-2">
                        Top Pages ({rankingData?.pages?.length || 0})
                      </h4>
                    </div>
                    <div className="ms-auto"></div>
                  </div>
                  <Table
                    className="border rounded-lg shadow-md"
                    columns={columns}
                    dataSource={rankingData?.pages || []}
                    onChange={onChange}
                    pagination={{ pageSize: 5 }} // Display 5 rows per page
                  />
                </>
              )}
            </div>
          )}

          {activeTab === "tab3" && (
            <div>
              <div className="flex">
                <div>
                  <h4 className="pb-4 text-[24px] font-[700]">User Activity</h4>
                  {Object.keys(domainList || {}).length > 0 && (
                    <h4 className="pb-4 text-[20px] font-[500] pb-2">
                      Identified Unique User
                    </h4>
                  )}
                </div>
                {Object.keys(domainList || {}).length > 0 && (
                  <div className="ms-auto">
                    <div className="mb-3">
                      <DatePicker.RangePicker
                        presets={rangePresets}
                        allowClear={false}
                        className="py-2"
                        value={[fromDateUserJ, toDateUserJ]}
                        format={"DD MMM YYYY"}
                        onChange={(dates) => {
                          setFromDateUserJ(dates?.length ? dates[0] : "");
                          setToDateUserJ(dates?.length ? dates[1] : "");
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>

              {loadingUserActivityData || domainLoading ? (
                // Skeleton layout for User Activity chart and table
                <div className="pb-4 space-y-6">
                  <div className="h-6 w-40 bg-gray-300 rounded skeleton-wave"></div>
                  <div className="w-full h-[300px] bg-gray-200 rounded-[20px] skeleton-wave"></div>
                  <div className="border rounded-lg shadow-md overflow-hidden bg-white">
                    <div className="grid grid-cols-4 gap-3 px-4 py-3 border-b border-[#E9EBF0] bg-[#FAFBFC]">
                      {[...Array(4)].map((_, index) => (
                        <div
                          key={index}
                          className="h-4 w-24 bg-gray-300 rounded skeleton-wave"
                        ></div>
                      ))}
                    </div>
                    <div className="divide-y divide-[#F5F5F5]">
                      {[...Array(4)].map((_, rowIndex) => (
                        <div
                          key={rowIndex}
                          className="grid grid-cols-4 gap-3 px-4 py-3"
                        >
                          {[...Array(4)].map((_, colIndex) => (
                            <div
                              key={colIndex}
                              className="h-4 w-full bg-gray-300 rounded skeleton-wave"
                            ></div>
                          ))}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {Object.keys(domainList || {}).length === 0 && (
                    <div className="text-center">
                      <h2 className="pb-4 text-[24px] font-[700]">
                        To start capturing visitor behavior on your website,
                        <br />
                        please install the script.
                      </h2>
                      <button
                        className="bg-gradient-to-r border border-[#000000] hover:border-[transparent] hover:bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-[#fff] h-[40px] w-[200px] rounded-full transition-all duration-300 hover:border-l-0 hover:border-r-0 text-[18px] font-[500]"
                        onClick={() => navigate("/script")}
                      >
                        Install Script
                      </button>
                    </div>
                  )}

                  {Object.keys(domainList || {}).length > 0 && (
                    <>
                      <div className="w-full h-[400px]">
                        <Suspense fallback={<p>Loading chart...</p>}>
                          <Plot
                            data={[
                              {
                                x: userActivityData?.graphData?.map((item) =>
                                  moment(item?.date).format("MMM DD")
                                ),
                                y: userActivityData?.graphData?.map(
                                  (item) => item?.count
                                ),
                                mode: "lines",
                                name:
                                  fromDateUserJ.format("D MMM YYYY") +
                                  " - " +
                                  toDateUserJ.format("D MMM YYYY"),
                                line: { color: "#077BA9", width: 2 },
                                hoverinfo: "none",
                                hovertemplate:
                                  "<b>%{x} vs %{customdata.date}</b><br>" +
                                  "Current Sessions: <b>%{y}</b> <br>" +
                                  "Preceding Sessions: <b>%{customdata.count}</b> <br>" +
                                  "<b>%{text}</b>" +
                                  "<extra></extra>",
                                text: userActivityData?.graphData?.map(
                                  (item) => {
                                    // Handle case when there's no historical data
                                    if (
                                      item.preceding_count === 0 ||
                                      item.preceding_count === null ||
                                      item.preceding_count === undefined
                                    ) {
                                      if (item.count > 0) {
                                        return `<span style='color:green;'>New Data</span>`;
                                      } else {
                                        return `<span style='color:gray;'>No Data</span>`;
                                      }
                                    }

                                    const percentage = (
                                      ((item.count - item.preceding_count) /
                                        item.preceding_count) *
                                      100
                                    ).toFixed(2);
                                    return percentage >= 0
                                      ? `<span style='color:green;'>▲ ${percentage}%</span>`
                                      : `<span style='color:red;'>▼ ${Math.abs(
                                        percentage
                                      )}%</span>`;
                                  }
                                ),
                                customdata: userActivityData?.graphData?.map(
                                  (item) => ({
                                    date: moment(item?.preceding_date).format(
                                      "MMM DD"
                                    ),
                                    count: item?.preceding_count,
                                  })
                                ),
                              },
                              {
                                x: userActivityData?.graphData?.map((item) =>
                                  moment(item?.date).format("MMM DD")
                                ),
                                y: userActivityData?.graphData?.map(
                                  (item) => item?.preceding_count
                                ), // Data for "Preceding period"
                                mode: "lines",
                                // (number of days in the preceding period) + " days"
                                name:
                                  "Preceding period (" +
                                  (toDateUserJ.diff(fromDateUserJ, "days") +
                                    1) +
                                  ") days",
                                line: {
                                  color: "#077BA9",
                                  width: 2,
                                  dash: "dash",
                                },
                                hoverinfo: "none",
                                // hovertemplate: 'Date: %{x}<br>Value: %{y}',
                              },
                            ]}
                            layout={{
                              // ...existing layout props...
                              autosize: true, // Add this
                              margin: {
                                // Add margins to prevent axis labels from being cut off
                                l: 50,
                                r: 20,
                                t: 20,
                                b: 50,
                              },
                              xaxis: {
                                title: "Date",
                                autorange: true,
                                showgrid: false,
                              },
                              yaxis: {
                                title: "Value",
                                // range: [0, 200],
                                autorange: true,
                                showgrid: true,
                                gridcolor: "#E5E5E5",
                              },
                              showlegend: true,
                              legend: {
                                orientation: "h",
                              },
                              hovermode: "x",
                              hoverdistance: 50,
                              spikedistance: 1000,
                              hoverlabel: {
                                bgcolor: "#FFF",
                                bordercolor: "#077BA9",
                                font: { size: 13 },
                                namelength: 0,
                              },
                              xaxis: {
                                showspikes: true,
                                spikecolor: "#077BA9",
                                spikesnap: "hovered data",
                                spikemode: "across",
                                spikethickness: 1,
                              },
                            }}
                            style={{ width: "100%", height: "100%" }}
                            useResizeHandler={true} // Add this
                            config={{
                              displayModeBar: false,
                              responsive: true, // Add this
                            }}
                          />
                        </Suspense>
                      </div>

                      <div className="flex flex-row sticky top-0 z-[16] bg-white items-center h-[80px]">
                        <h4 className="text-[24px] font-[700]">
                          List of Unique User
                        </h4>

                        <div className="ms-auto flex gap-2">
                          <div className="">
                            <select className="rounded-lg font-[400] text-[16px] border border-[#E9EBF0] bg-[#FAFBFC]" value={sessionType} onChange={(e) => setSessionType(e.target.value)}>
                              <option value="1">All</option>
                              <option value="2">Identified</option>
                              <option value="3">Unidentified</option>
                            </select>
                          </div>
                          <div className="">
                            <DatePicker.RangePicker
                              presets={rangePresets}
                              allowClear={false}
                              value={[fromDateUserK, toDateUserK]}
                              format={"DD MMM YYYY"}
                              onChange={(dates) => {
                                setFromDateUserK(dates?.length ? dates[0] : "");
                                setToDateUserK(dates?.length ? dates[1] : "");
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <table
                        align="center"
                        className="w-full rounded-[20px] userActiveTbl"
                      >
                        <thead className="sticky top-[80px] z-[15] bg-white border-b rounded-t-[20px]">
                          <tr>
                            <th>Unique User</th>
                            <th>Country</th>
                            <th>Total Session</th>
                            <th>Avg Time/Session</th>
                            {/* <th>Intent</th> */}
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody >
                          {userList?.map((item, index) => {
                            // Ensure user_uniq_id exists
                            const userUniqId = item?.user_uniq_id || (item?._id ? uuidV5(item._id, NAMESPACE) : null);
                            return (
                              <tr className="fade-in">
                                <td
                                  style={{
                                    maxWidth: "250px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {item?.leaddata ? item?.leaddata?.exactPerson?.firstName + " " + item?.leaddata?.exactPerson?.lastName : userUniqId}
                                </td>
                                <td>{item?.ip_country}</td>
                                <td>{item?.uniqueSessions?.length}</td>
                                {/* <td>
                            {
                              //suppose if we have 3 sessions and avg time spent is 10, 20, 30 then we will calculate avg time spent as (10+20+30)/3 = 20
                              item?.uniqueSessions?.reduce(
                                (acc, curr) => acc + (curr?.time_spent || 0),
                                0
                              ) / item?.uniqueSessions?.length
                            }
                          </td> */}
                                <td>
                                  {item?.avgTimeSpent ? (
                                    Math.round((item?.avgTimeSpent / 60) * 10) /
                                    10 +
                                    " Min"
                                  ) : (
                                    <span>&nbsp;</span>
                                  )}
                                </td>
                                {/* <td>{item?.avgTimeSpent ? item?.avgTimeSpent + ' Min' : ''}</td> */}
                                {/* <td></td> */}
                                <td>
                                  <div className="flex mr-2">
                                    <button
                                      type="button"
                                      onClick={async () => {
                                        // Open DetailsDrawer instead of modal
                                        setDrawerData({
                                          ...item?.leaddata,
                                          customData: {
                                            session_id: userUniqId,
                                          },
                                          user_uniq_id: userUniqId,
                                        });
                                        setIsDrawerOpen(true);

                                        // Keep the old modal code commented below
                                        // setOpenModal(item?._id);
                                        // await getUserIdJourney(
                                        //   userUniqId
                                        // );
                                      }}
                                      className="py-1 mx-auto h-[44px] w-full max-w-[180px] rounded-full text-[16px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-white hover:transition hover:delay-75 flex items-center justify-center"
                                    >
                                      View
                                      <svg className="icon text-[26px] ms-3">
                                        <use href="#icon_rightarrow"></use>
                                      </svg>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <div ref={loadMoreTriggerRef} id="load-more-trigger" className="h-10"></div>
                      {loading && (
                        <div className="load-more-triggerloader flex justify-between items-center py-4 space-x-3 border-b border-[#E9EBF0]">
                          <div className="w-60 h-3 bg-gray-300 rounded-full skeleton-wave"></div>
                          <div className="w-20 h-3 bg-gray-300 rounded-full skeleton-wave"></div>
                          <div className="w-10 h-3 bg-gray-300 rounded-full skeleton-wave"></div>
                          <div className="w-10 h-3 bg-gray-300 rounded-full skeleton-wave"></div>
                          <div className="w-20 h-10 bg-gray-300 rounded-full skeleton-wave"></div>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>

      {/* DetailsDrawer for User Journey */}
      <DetailsDrawer
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        drawerData={drawerData}
        setDrawerData={setDrawerData}
        drawerLoading={false}
        activeTab={null}
      />

      {/* Commented out - Old Modal for User Journey */}
      {false && (
        <Modal
          dismissible
          show={openModal}
          onClose={() => {
            setOpenModal(false);
            setUserIdJourneyData([]);
          }}
        >
          <Modal.Header className="font-bold">User Journey</Modal.Header>
          <Modal.Body className="px-[40px]">
            {/* <div className="bg-[#F7F7F7] flex justify-between p-5">
            <div>Session 01</div>
            <div>Pages</div>
            <div>Entry: </div>
            <div>Exit: </div>
          </div> */}
            {loadingUserIdJourney && (
              <div className="pb-4 space-y-4">
                <div className="h-6 w-48 bg-gray-300 rounded skeleton-wave"></div>
                <div className="space-y-3">
                  {[...Array(3)].map((_, index) => (
                    <div
                      key={index}
                      className="flex justify-between items-center px-4 py-3 border border-[#E9EBF0] rounded-[16px] bg-white"
                    >
                      <div className="h-4 w-24 bg-gray-300 rounded skeleton-wave"></div>
                      <div className="h-4 w-32 bg-gray-300 rounded skeleton-wave"></div>
                      <div className="h-4 w-16 bg-gray-300 rounded skeleton-wave"></div>
                      <div className="h-4 w-40 bg-gray-300 rounded skeleton-wave"></div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className="UserPopAccordion">
              <Accordion>
                {userIdJourneyData?.map((item, index) => (
                  <Accordion.Panel>
                    <Accordion.Title key={item?.session_id}>
                      <div className="flex justify-between w-full">
                        <div className="font-bold text-[20px] flex items-center">
                          Session {index + 1}
                        </div>
                        {/* <div className="font-bold text-[20px] flex items-center">
                        {item?.session_id}
                        </div> */}
                        <div className="font-bold text-[20px] flex items-center">
                          {item?.data[0]?.ip_contry}
                          <br />
                          {item?.data[0]?.city}
                        </div>
                        <div className="flex">
                          <svg className="icon text-[18px] me-2 mt-1">
                            <use href="#icon_pagecopy"></use>
                          </svg>
                          <div className="font-bold text-[18px]">
                            <p>Pages</p>
                            <p>{item?.data?.length}</p>
                          </div>
                        </div>
                        <div className="flex">
                          <svg className="icon text-[18px] me-2 mt-1">
                            <use href="#icon_entry"></use>
                          </svg>
                          <div className="font-bold text-[18px]">
                            <p>Entry:</p>
                            {/* <p>Feb 03, 2024 | 10:00 AM</p> */}
                            {moment(item?.data?.at(0)?.createdAt).format(
                              "MMM DD, YYYY | hh:mm A"
                            )}
                          </div>
                        </div>

                        <div className="flex">
                          <svg className="icon text-[18px] me-2 mt-1">
                            <use href="#icon_exit"></use>
                          </svg>
                          <div className="font-bold text-[18px]">
                            <p>Exit: </p>
                            {/* <p>Feb 03, 2024 | 10:05 AM</p> */}
                            {getLatestUpdatedAt(item?.data) ? (
                              moment(getLatestUpdatedAt(item?.data)).format(
                                "MMM DD, YYYY | hh:mm A"
                              )
                            ) : (
                              <span></span>
                            )}
                            {/* 
                          {moment(item?.data?.at(-1)?.createdAt).format(
                            "MMM DD, YYYY | hh:mm A"
                          )} */}
                          </div>
                        </div>
                      </div>
                    </Accordion.Title>
                    <Accordion.Content>
                      <div>
                        <Timeline
                          className="my-3"
                          mode={"left"}
                          items={
                            item?.data?.map((link, index) => {
                              return {
                                // label: moment(link?.createdAt).format("hh:mm A"),
                                label: (
                                  <span>
                                    {formatTimeLabel(item?.data, link?.createdAt)}

                                    {index == 0 && (
                                      <svg className="icon text-[16px] ms-2">
                                        <use href="#icon_entry"></use>
                                      </svg>
                                    )}
                                    {index == item?.data?.length - 1 && (
                                      <svg className="icon text-[16px] ms-2">
                                        <use href="#icon_exit"></use>
                                      </svg>
                                    )}
                                  </span>
                                ),
                                children: (
                                  <>
                                    <a
                                      href={link?.page_url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {link?.page_url}
                                    </a>

                                    <div className="flex items-center">
                                      <span title="Time Spent">
                                        <svg className="icon text-[16px]">
                                          <use href="#icon_clock"></use>
                                        </svg>
                                        {link?.time_spent || 0} Sec,
                                      </span>
                                      <span title="Scroll Depth">
                                        <svg className="icon text-[16px]">
                                          <use href="#icon_mouse"></use>
                                        </svg>
                                        {link?.scroll_depth || 0}%,{" "}
                                      </span>
                                      <span title="Page View Count">
                                        <svg className="icon text-[16px]">
                                          <use href="#icon_eye"></use>
                                        </svg>
                                        {link?.count},
                                      </span>
                                      <span title="Links Clicked">
                                        <svg className="icon text-[16px]">
                                          <use href="#icon_cursor"></use>
                                        </svg>
                                        {link?.links_clicked?.length || 0}
                                        {link?.links_clicked?.length > 0 && ","}
                                      </span>
                                      {link?.links_clicked?.map(
                                        (linkClicked, index) => (
                                          <>
                                            <a
                                              href={linkClicked?.link}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              {linkClicked?.link}
                                            </a>
                                            {
                                              //if it is not the last element then add a comma
                                              index !==
                                              link?.links_clicked?.length - 1 &&
                                              ", "
                                            }
                                          </>
                                        )
                                      )}
                                    </div>
                                  </>
                                ),
                              };
                            }) || []
                          }
                        />
                      </div>
                    </Accordion.Content>
                  </Accordion.Panel>
                ))}

                {/* <Accordion.Panel>
                <Accordion.Title>
                  <div className="flex justify-between w-full">
                    <div className="font-bold text-[20px] flex items-center">Session 02</div>
                    <div className="flex">
                      <svg className="icon text-[18px] me-2 mt-1">
                        <use href="#icon_pagecopy"></use>
                      </svg>
                      <div className="font-bold text-[18px]">
                        <p>Pages</p>
                        <p>04</p>
                      </div>
                    </div>
                    <div className="flex">
                      <svg className="icon text-[18px] me-2 mt-1">
                        <use href="#icon_entry"></use>
                      </svg>
                      <div className="font-bold text-[18px]">
                        <p>Entry:</p>
                        <p>Feb 03, 2024 | 10:00 AM</p>
                      </div>
                    </div>

                    <div className="flex">
                      <svg className="icon text-[18px] me-2 mt-1">
                        <use href="#icon_exit"></use>
                      </svg>
                      <div className="font-bold text-[18px]">
                        <p>Exit: </p>
                        <p>Feb 03, 2024 | 10:05 AM</p>
                      </div>
                    </div>
                  </div>
                </Accordion.Title>
                <Accordion.Content>
                  <p className="mb-2 text-gray-500 dark:text-gray-400">
                    Flowbite is first conceptualized and designed using the Figma software so everything you see in the library
                    has a design equivalent in our Figma file.
                  </p>
                  <p className="text-gray-500 dark:text-gray-400">
                    Check out the
                    <a href="https://flowbite.com/figma/" className="text-cyan-600 hover:underline dark:text-cyan-500">
                      Figma design system
                    </a>
                    based on the utility classes from Tailwind CSS and components from Flowbite.
                  </p>
                </Accordion.Content>
              </Accordion.Panel> */}
              </Accordion>
            </div>
          </Modal.Body>
          {/* <Modal.Footer>
          <Button onClick={() => setOpenModal(false)}>I accept</Button>
          <Button color="gray" onClick={() => setOpenModal(false)}>
            Decline
          </Button>
        </Modal.Footer> */}
        </Modal>
      )}
    </>
  );
});

export default Chat;
